import { create } from "zustand";
import { StoreMapCompanyUserProps } from "./interface/company-user.interface";
import {
  createAndAssign,
  deleteUser,
  getAllCompany,
  getAllCompanyRoleByUserId,
  getCompanyIamCompanyAdmin,
  getMyAssignCompany,
  getUserManagement,
  updateAssignRoles,
} from "src/services/map-company-user.service";
import { BodyCreateWithAssign, BodyUpdateWithAssign } from "src/entity/map-company-user/map-company-user";
import { CommonError } from "src/entity/common/menus-enum.enum";
import Modal from "src/components/Modal";
import { GetUserManagementFilter } from "src/entity/user-management/users-state.entity";

export const companyUserStore = create<StoreMapCompanyUserProps>((set) => ({
  loading: false,
  company: [],
  error: null,
  userInCompany: {
    data: [],
    total: 0,
  },
  loadingUserInCompany: false,
  dataManageUser: null,
  loadingManageUser: false,
  loadingDeleteUser: false,
  loadingCompanyUserById: false,
  dataGetUserById: null,
  dataIamCompanyAdmin: [],
  requestAllCompany: async () => {
    set(() => ({ loading: true }));
    try {
      const res = await getAllCompany();
      // console.log("respone get my company : ", res);
      set(() => ({ loading: false, company: res.data?.data ?? [], error: null }));
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message, company: [] }));
    }
  },
  requestUserManagement: async (filter: GetUserManagementFilter = {}) => {
    set(() => ({ loadingUserInCompany: true }));
    try {
      const res = await getUserManagement(filter);
      // console.log("respone get user in comany : ", res);
      set(() => ({ loadingUserInCompany: false, userInCompany: res.data?.data, error: null }));
    } catch (err: any) {
      set(() => ({ loadingUserInCompany: false, error: err?.message, userInCompany: { data: [], total: 0 } }));
    }
  },
  requestCreateWithAssign: async (body: BodyCreateWithAssign) => {
    set(() => ({ loadingManageUser: true }));
    try {
      const res = await createAndAssign(body);
      // console.log("respone create user in comany : ", res);
      set(() => ({ loadingManageUser: false, dataManageUser: res.data?.data ?? [], error: null }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageUser: false, error: message, dataManageUser: message }));
      return message;
    }
  },
  requestUpdateWithAssign: async (body: BodyUpdateWithAssign) => {
    set(() => ({ loadingManageUser: true }));
    try {
      const res = await updateAssignRoles(body);
      // console.log("respone update user in comany : ", res);
      set(() => ({ loadingManageUser: false, error: null }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageUser: false, error: message }));
      return message;
    }
  },
  requestDeleteUser: async (userId: string) => {
    set(() => ({ loadingDeleteUser: true }));
    try {
      const res = await deleteUser(userId);
      // console.log("respone delete user : ", res);
      set(() => ({ loadingDeleteUser: false, error: null }));
    } catch (err: any) {
      // console.log("Error : ", err);
      const finalMessage = err?.response?.data?.message || CommonError.SOMETHING_WRONG;
      Modal.error({
        title: "Delete Failure",
        message: finalMessage,
        closeAfter: 3000,
        forceMaskClose: true,
        showFooter: false,
      });
      set(() => ({ loadingDeleteUser: false, error: finalMessage }));
    }
  },
  getAllCompanyRoleByUserId: async (userId: string) => {
    set(() => ({ loadingCompanyUserById: true }));
    try {
      const res = await getAllCompanyRoleByUserId(userId);
      // console.log("respone delete user : ", res);
      set(() => ({ loadingCompanyUserById: false, dataGetUserById: res.data?.data || null }));
      return res.data?.data || null;
    } catch (err: any) {
      // const finalMessage = err?.response?.data?.message || CommonError.SOMETHING_WRONG;
      set(() => ({ loadingCompanyUserById: false, dataGetUserById: null }));
    }
  },
  getCompanyIamCompanyAdmin: async () => {
    set(() => ({ loadingCompanyUserById: true }));
    try {
      const res = await getCompanyIamCompanyAdmin();
      // console.log("respone delete user : ", res);
      set(() => ({ loadingCompanyUserById: false, dataIamCompanyAdmin: res.data?.data || null }));
      return res.data?.data || null;
    } catch (err: any) {
      // const finalMessage = err?.response?.data?.message || CommonError.SOMETHING_WRONG;
      set(() => ({ loadingCompanyUserById: false, dataIamCompanyAdmin: [] }));
    }
  },
  clearDataIamCompanyAdmin: async () => {
    set(() => ({ dataIamCompanyAdmin: [] }));
  },
  clearDataGetUserById: async () => {
    set(() => ({ dataGetUserById: null }));
  },
  clearError: async () => {
    set(() => ({ error: null }));
  },
}));
